const initialState = {
    user: null,
    loading: false,
    error: null,
  };
  
  const loginReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'LOGIN_USER_REQUEST':
        return { ...state, loading: true };
      case 'LOGIN_USER_SUCCESS':
        return { ...state, loading: false, user: action.payload };
      case 'LOGIN_USER_FAILURE':
        return { ...state, loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  export default loginReducer;
  